import _ from 'lodash';

import { createToast, toastType } from '../../common/ToastHelper';

/**
 * Check if selected mapping option is not already selected.
 * If not selected add to columnMapping array.
 * If selected return false and an unaltered columnMapping array.
 *
 * @param {string} columnValue
 * @param {int} columnNumber
 * @param {array} columnMapping
 * @param {array} columnsOptions
 * @param {Number} longestLineLength
 */
export const validateColumnData = (
  columnValue,
  columnNumber,
  currentMapping = [],
  columnsOptions = [],
  headerId = 1,
  longestLineLength
) => {
  let success = false,
    newColumnMapping = _.cloneDeep(currentMapping);

  newColumnMapping = newColumnMapping.filter(
    c => c.ColumnNumber !== columnNumber && c.Id !== columnValue
  );

  // Get the column option from fixture list
  const option = columnsOptions
    .filter(optObj => optObj.value === columnValue)
    .shift();

  // Get the current column from the columnMapping list
  const column = currentMapping
    .filter(column => column.FieldName === option.text)
    .shift();

  // The user selected the same field on the same column. Silly.
  if (column && column.ColumnNumber === columnNumber) {
    success = true;
  } else if (!column) {
    // No column from the current list is found, it's a new column!
    success = true;

    newColumnMapping.push({
      HeaderId: headerId,
      FieldName: option.text,
      ColumnNumber: columnNumber,
    });
  } else if (column.ColumnNumber >= longestLineLength) {
    // If the option is already used in the current mapping list but isn't displayed on the table,
    // allow the option to be used
    success = true;
    const existingColumn = newColumnMapping
      .filter(c => c.FieldName === option.text)
      .shift();

    if (existingColumn) {
      existingColumn.ColumnNumber = columnNumber;
    }
  }

  // If the user skips the column, remove the column from the mapping.
  if (columnValue === -1) {
    success = true;

    newColumnMapping = newColumnMapping.filter(c => {
      return c.ColumnNumber !== columnNumber;
    });
  }

  return [success, success ? newColumnMapping : currentMapping, option];
};

/**
 * Display single error or display a list of errors based on fields.
 *
 * string error
 * array fields
 *
 * @param {object} param0
 */
export const displayErrors = ({ error, fields }) => {
  if (error) {
    createToast(toastType.error, 'Error', error);
  }

  if (!error && fields.length) {
    fields.forEach(required => {
      createToast(toastType.error, 'Error', required + ' is required');
    });
  }
};

/**
 *
 * @param {object} importConfigFormValues
 */
export const getDefaultMealStatusPrompt = (
  importConfigFormValues,
  mealStatuses
) => {
  return () => {
    if (!importConfigFormValues) {
      return;
    }
    const defaultMealStatus = mealStatuses
      .filter(m => {
        return importConfigFormValues.mealStatusDropDown === m.value;
      })
      .shift();

    return `All new accounts in the file being imported will have a status of ${defaultMealStatus.text}`;
  };
};



// WEBPACK FOOTER //
// ./src/pages/importstudents/ImportStudentHelper.js